<template>
  <div v-if="regiony.length" ref="componentTop" class="layout-segment">
    <div class="layout-segment__header">
      <h3 class="layout-segment__title">Top regiony</h3>
    </div>
    <section
      class="top-regions"
      ref="topRegions"
      :class="{ _expanded: isExpanded }"
      :style="styleVars"
    >
      <div
        ref="regionItem"
        class="region-item"
        v-for="(region, idx) in regiony"
        :key="idx"
      >
        <div class="region-item__inner font-m">
          <a
            class="region-item__link"
            :href="getUrl(region.url)"
            :title="region.nazwa"
          >
            {{ region.nazwa }}
          </a>
          <span class="region-item__price"
            >od <span class="font-20">{{ region.cena }}</span> zł</span
          >
        </div>
      </div>
    </section>
    <div class="collapser-line" v-if="showToggle">
      <div @click="handleExpand()" class="collapser-line__button">
        <span class="collapser-line__label">{{
          isExpanded ? "Mniej regionów" : "Więcej regionów"
        }}</span>
        <span :class="{ _flip: isExpanded }" class="up-down-arrow"
          ><span></span><span></span
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as CONFIG from "../config.js";

export default {
  name: "top-regiony-home",
  data: () => ({
    url: "/vueregions.json",
    itemHeight: 0,
    regionsWrapperHeight: 0,
    regionsMaxWrapperHeight: 0,
    isExpanded: false,
    showToggle: false,
    regiony: [],
  }),
  methods: {
    getRegiony() {
      return axios
        .get(CONFIG.API_URL + this.url, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json",
          },
        })
        .then((response) => {
          return response.data;
        })
        .catch((e) => {
          alert("ERROR" + e);
        });
    },
    handleExpand() {
      const componentTop = this.$refs.componentTop;
      this.isExpanded = !this.isExpanded;

      if (!this.isExpanded) {
        setTimeout(() => {
          componentTop.scrollIntoView({ behavior: "smooth" });
        }, 50);
      }
    },
    getUrl(url) {
      if (url.indexOf("www.") != -1) {
        let index = url.indexOf(".pl/");
        return url.substring(index + 3);
      } else {
        return "https://" + url;
      }
    },
    tomatrix(obj) {
      if (obj != undefined) {
        if (obj instanceof Array) {
          return obj;
        } else {
          let z = [];
          z.push(obj);
          return z;
        }
      } else {
        return [];
      }
    },
    handleResize() {
      if (this.regiony.length) {
        const regionsWrapper = this.$refs.topRegions;
        const item = this.$refs.regionItem[0];

        this.itemHeight = item.clientHeight - 1;
        this.regionsWrapperHeight = regionsWrapper.clientHeight;
        this.regionsMaxWrapperHeight = this.regiony.length * this.itemHeight;
      }
    },
  },
  mounted() {
    this.getRegiony()
      .then((data) => {
        this.regiony = this.tomatrix(data.regiony.item);
        if (this.regiony.length > 6) {
          this.showToggle = true;
        }
      })
      .catch(() => {
        this.regiony;
      });
  },
  created() {
    window.addEventListener("resize", this.handleResize, { passive: true });
  },
  updated() {
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize, { passive: true });
  },
  computed: {
    styleVars() {
      let cssVars =
        "--tr-height: " +
        this.itemHeight +
        "px;" +
        "--tr-mheight: " +
        (this.regionsMaxWrapperHeight + 180) +
        "px;";
      return cssVars;
    },
  },
};
</script>

<style lang="scss" scoped>
.top-regions {
  max-height: calc(6 * var(--tr-height));
  overflow: hidden;
  transition: all 0.2s linear;

  @media (min-width: $screen-xs) {
    display: flex;
    flex-wrap: wrap;
    margin-left: -12px;
    margin-right: -12px;
    max-height: calc(3 * var(--tr-height));
  }

  @media (min-width: $screen-md) {
    max-height: calc(2 * var(--tr-height));
  }

  &._expanded {
    max-height: calc(var(--tr-mheight));

    @media (min-width: $screen-xs) {
      max-height: calc(var(--tr-mheight) / 2);
    }

    @media (min-width: $screen-md) {
      max-height: calc(var(--tr-mheight) / 3);
    }
  }
}

.region-item {
  position: relative;
  padding-bottom: 18px;

  @media (min-width: $screen-xs) {
    padding: 0 12px 24px;
    width: 50%;
  }

  @media (min-width: $screen-md) {
    width: percentage(1/3);
  }

  &__inner {
    border: 1px solid $border-color;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 14px 12px;
    position: relative;
    height: 100%;

    &:hover {
      @include shadow();
    }
  }

  &__link {
    @include text-truncate();
    color: $text-color-default;
    display: block;
    padding-right: 24px;
    text-decoration: none;

    &::after {
      content: "";
      background: transparent;
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }

    @media (min-width: $screen-md) {
      padding-right: 0;
      margin-bottom: 2px;
    }
  }

  &__price {
    color: #eb3e27;
    white-space: nowrap;
  }
}
</style>
